module.exports = __webpack_public_path__ + "static/media/car-side.375f719a.svg";